import React, { PureComponent } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Utils from '../../utils/Utils';
import HighchartsExporting from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import HighChartsMore from 'highcharts/highcharts-more';

HighChartsMore(Highcharts);

class Chart extends PureComponent {
  constructor() {
    super();

    HighchartsExporting(Highcharts);
    HighChartsMore(Highcharts);

    Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
      return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
    };

    Highcharts.SVGRenderer.prototype.symbols.slash = function (x, y, w, h) {
      return ['M', x + w, y + h, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
    };

    Highcharts.dateFormats = {
      E: Utils.determineDaysHourMinSecFromTicks,
    };

    Highcharts.defaultOptions.credits.enabled = false;

    Highcharts.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              'printChart',
              'separator',
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
            ],
          },
        },
      },
    });
  }

  componentDidMount() {
    let chart = this.refs.chart ? this.refs.chart.chart : null;
    if (chart) {
      chart.options.exporting.sourceWidth = chart.chartWidth;
      chart.options.exporting.sourceHeight = chart.chartHeight;
      chart.options.exporting.filename = chart.title.textStr + 'Chart';
    }
  }

  render() {
    return (
      <div className="chart-wrapper" data-qa="qa-chart">
        {this.props.config &&
        this.props.config.series.length &&
        this.props.metadata &&
        this.props.metadata.Count ? (
          <HighchartsReact
            options={this.props.config}
            ref="chart"
            highcharts={Highcharts}
            constructorType="chart"
          />
        ) : (
          <p>No data to show</p>
        )}
      </div>
    );
  }
}

export default Chart;
